import type { StoreState, StateRef, GlobalStore, MainState, AuthState, Dispatch, Listener } from './stateTypes'

let dispatchFn = (() => {
  throw new Error('state store is not initialized yet')
}) as Dispatch
export const updateDispatchFn = (dispatch: Dispatch) => { // ensure internal, do not export
  dispatchFn = dispatch
}

let currentState = {} as StoreState // ensure not null
export const stateRef: StateRef = Object.freeze({
  get current() {
    return currentState
  },
  get dispatch() {
    return dispatchFn
  },
})

const WARN_MAX_LISTENERS = 100
const listeners = new Set<Listener>()
const emit = (state: StoreState, previousState: StoreState) => {
  Array.from(listeners).forEach((listener) => {
    try {
      listener(state, previousState)
    }
    catch (e) {
      console.error('global store listener throw error', e)
    }
  })
}

export const updateStateAndEmit = (state: StoreState) => { // ensure internal, do not export
  if (state !== currentState) {
    const previousState = currentState
    currentState = state
    emit(state, previousState)
  }
  return state
}

export const getState = (): StoreState => currentState
export const getMainState = () => (currentState.main || {}) as MainState
export const getAuthState = () => (currentState.auth || {}) as AuthState

export const dispatch: Dispatch = (action) => dispatchFn(action)
export const subscribe = (listener: Listener) => {
  if (typeof listener !== 'function') {
    throw new Error('store.subscribe expects 1 argument of type function')
  }
  listeners.add(listener)
  if (listeners.size > WARN_MAX_LISTENERS) {
    console.warn('too many store subscribe listeners', listeners.size)
  }
  return () => {
    listeners.delete(listener)
  }
}

export const store = {
  dispatch,
  subscribe,
  getState,
  stateRef,
} as GlobalStore

export type Store = GlobalStore

export default store
